export const reserveStates = {
  waitSignIn: {
    value: 0,
    name: '预约成功待签到',
    shortName: '待签到',
    icon: 'wait-sign-in',
  },
  signedIn: {
    value: 1,
    name: '签到',
    shortName: '已签到',
    icon: 'signed-in',
  },
  queuing: {
    value: 2,
    name: '排队中',
    shortName: '排队中',
    icon: 'queuing',
  },
  queueFailed: {
    value: 3,
    name: '排队失败',
    shortName: '排队失败',
    icon: 'queue-failed',
  },
  signCanceled: {
    value: 4,
    name: '取消预约',
    shortName: '取消预约',
    icon: 'sign-canceled',
  },
  queueCanceled: {
    value: 5,
    name: '取消排队',
    shortName: '取消排队',
    icon: 'queue-canceled',
  },
  signedInCancelled: {
    value: 10,
    name: '取消签到',
    shortName: '取消签到',
    icon: 'sign-canceled',
  },
  signBroken: {
    value: 6,
    name: '爽约',
    shortName: '已爽约',
    icon: 'sign-broken',
  },
  waitSignInNotPay: {
    value: 7,
    name: '预约成功待支付',
    shortName: '待支付',
    icon: 'wait-pay',
  },
  queuingNotPay: {
    value: 8,
    name: '排队成功待支付',
    shortName: '待支付',
    icon: 'wait-pay',
  },
  payClosed: {
    value: 9,
    name: '已取消支付',
    shortName: '取消支付',
    icon: 'pay-closed',
  },
};

// 只有以下状态才可设置为爽约
const signStates = [
  reserveStates.waitSignIn.value,
  reserveStates.signedIn.value,
];

export const isSignStates = (state) => signStates.includes(state);

export function getReservationNameByState(state) {
  for (let key in reserveStates) {
    if (reserveStates[key].value === state) return reserveStates[key].name;
  }
}

export function getReservationShortNameByState(state) {
  for (let key in reserveStates) {
    if (reserveStates[key].value === state) return reserveStates[key].shortName;
  }
}

export function getReservationIconByState(state) {
  for (let key in reserveStates) {
    if (reserveStates[key].value === state) return reserveStates[key].icon;
  }
}
